<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />

    <van-skeleton :row="10" :loading="loading">
      <div class="pageRect">
        <div class="title">{{ data.examName }}答题卡</div>
        <div class="time">
          <van-row>
            <van-col span="12">测试时间:{{ formatDate(data.starTime,"yyyy/MM/dd") }}</van-col>
            <van-col span="12" class="rigth">结果:{{ data.isPass?'通过':'未通过' }}</van-col>
          </van-row>
        </div>
        <div v-for="item in data.list" :key="item.id" class="line">
          <van-row>
            <van-col span="2">{{ item.id }}</van-col>
            <van-col span="22"><span v-for="(line,index) in item.answer" :key="index">{{ line }}</span><br></van-col>
          </van-row>

        </div>
      </div>
    </van-skeleton>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetBaseTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '答题卡',
      id: undefined,
      backurl: '/dive',
      loading: false,
      data: {
        list: []
      }
    }
  },

  created() {
    this.id = this.$route.params.id
    this.titleTop = GetBaseTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetBaseTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      request({
        url: '/DiveLearn/getExamOutput',
        method: 'post',
        params: {
          id: this.id
        }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    }
  }
}
</script>
<style scoped>
.pageRect{
    padding: 1em;
    margin: 1em;
    background-color: #fff;
    box-shadow:5px 5px 10px #999;
}

.pageRect .title{
    font-size: 0.8em;
    font-weight: 700;
    text-align: center;
    padding: 1em 0;
}
.pageRect  .time{
    color: #999;
    font-size: 0.7em;
    border-bottom: 0.5em;
}

.pageRect .line{
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.8em;
    padding: 0.5em 0;
}
.pageRect .line:last-child{
    border-bottom: none;
}
</style>
